$shm_hitalama_components_version $mol_page
	entry $shm_hitalama_components_versions_entry
	minimal_width 480
	body /
		<= Note $mol_text
			text <= note \
		<= Details $mol_text
			text <= details \
		<= Commit $mol_link
			uri <= commit_uri \
			title <= commit_title \
			target \_blank
